import { render, staticRenderFns } from "./StudentElectivesNew.vue?vue&type=template&id=0d68887a&scoped=true"
import script from "./StudentElectivesNew.vue?vue&type=script&lang=js"
export * from "./StudentElectivesNew.vue?vue&type=script&lang=js"
import style0 from "./StudentElectivesNew.vue?vue&type=style&index=0&id=0d68887a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d68887a",
  null
  
)

export default component.exports